module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0123.jpg?v=626712ba";